type SectionHeadProps = {
  no: string;
  eyebrow: string;
  title: string;
  desc?: string;
  linkLabel?: string;
};

export default function SectionHead({
  no,
  eyebrow,
  title,
  desc,
  linkLabel,
}: SectionHeadProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2.5 mb-2">
          <span className="font-heading text-sm md:text-base font-bold tracking-tight text-primary-600">
            {no}
          </span>
          <span className="h-px w-6 bg-primary-300" />
          <span className="text-xs md:text-sm font-semibold tracking-widest text-foreground-600 uppercase">
            {eyebrow}
          </span>
        </div>
        <h2 className="text-2xl md:text-4xl font-extrabold tracking-tight text-foreground-950">
          {title}
        </h2>
        {desc && (
          <p className="mt-2.5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {desc}
          </p>
        )}
      </div>
      {linkLabel && (
        <a
          href="#"
          aria-label={linkLabel}
          className="shrink-0 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-foreground-700 border border-background-300 rounded-full px-4 py-2 bg-background-50 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-up-line text-[15px]" />
        </a>
      )}
    </div>
  );
}